import { render, staticRenderFns } from "./mentalHealth.vue?vue&type=template&id=52ecf3d5"
import script from "./mentalHealth.vue?vue&type=script&lang=js"
export * from "./mentalHealth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports